import React, { memo, useCallback, useState } from "react";
import moment from "moment";
import toast from "react-hot-toast";
import Status from "../../../../Utils/Status/Status";
import Backend from "../../../../Backend/Backend";
import "./List.css";

const fmt = require("indian-number-format");
const backend = await new Backend().init();

const formatNumber = (num) => {
  const val = parseFloat(num);
  return isNaN(val) ? "0" : fmt.format(val.toFixed(0));
};
function ListCard({ item, userType, reload, filteredUsers }) {
  const {
    id,
    name,
    username,
    master_username,
    super_username,
    deposit_total,
    deposit_current,
    profit_loss,
    net_profit_loss,
    trade,
    only_sq,
    status,
    ip,
    date_created,
    last_login_date,
    nse,
    nse_cash,
    mcx,
    mcx_options,
    options,
    comex,
    crypto,
    forex,
    sgx,
    us_stock,
    index,
    dgcx,
    ncdex,
    margin_nse,
    margin_nse_cash,
    margin_mcx,
    margin_mcx_options,
    margin_options,
    margin_comex,
    margin_crypto,
    margin_forex,
    margin_sgx,
    margin_us_stock,
    margin_index,
    margin_dgcx,
    margin_ncdex,

    margin_nse_carry,
    margin_nse_cash_carry,
    margin_mcx_carry,
    margin_mcx_options_carry,
    margin_options_carry,
    margin_comex_carry,
    margin_crypto_carry,
    margin_forex_carry,
    margin_sgx_carry,
    margin_us_stock_carry,
    margin_index_carry,
    margin_dgcx_carry,
    margin_ncdex_carry,
    b_nse,
    b_nse_cash,
    b_mcx_lot,
    b_mcx_volume,
    b_mcx_options,
    b_options,
    b_comex,
    b_crypto,
    b_forex,
    b_sgx,
    b_us_stock,
    b_index,
    b_dgcx,
    b_ncdex,
    auto_sq,
    lot_volume,
    intraday_sq,
  } = item;

  const [openClearModal, setOpenClearModal] = useState(false);
  const [openCopyModal, setOpenCopyModal] = useState(false);
  const [tpassword, setTpassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);

  // 🔹 New: Copy options
  const [copyOptions, setCopyOptions] = useState({
    brokerage: false,
    margin: false,
    symbol_qty: false,
    balance: false,
  });

  // 🔹 Handle Checkbox toggle
  const toggleUserSelection = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId],
    );
  };

  // 🔹 Handle Copy Submit
  const handleCopy = async () => {
    if (selectedUsers.length === 0) {
      toast.error("Please select at least one user");
      return;
    }

    const hasOptionSelected =
      copyOptions.brokerage ||
      copyOptions.margin ||
      copyOptions.symbol_qty ||
      copyOptions.balance;

    if (!hasOptionSelected) {
      toast.error("Please select at least one copy option");
      return;
    }

    try {
      setLoading(true);

      const data = {
        server: localStorage.getItem("server"),
        id: localStorage.getItem("id"),
        username: localStorage.getItem("username"),
        token: localStorage.getItem("token"),

        source_user_id: id,
        target_user_ids: selectedUsers,

        // New options
        copy_brokerage: copyOptions.brokerage,
        copy_margin: copyOptions.margin,
        copy_symbol_qty: copyOptions.symbol_qty,
        copy_broker: copyOptions.broker,
      };

      const res = await backend.copy_data(data);

      if (res?.error === "False") {
        toast.success(res?.message || "Data copied successfully");
        setOpenCopyModal(false);
        setSelectedUsers([]);
        setCopyOptions({
          brokerage: false,
          margin: false,
          symbol_qty: false,
          balance: false,
        });
      } else {
        toast.error(res?.message || "Copy failed");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error copying user data");
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Clear data logic
  const handleClear = async () => {
    if (!tpassword) {
      toast.error("Please enter transaction password");
      return;
    }

    const data = {
      server: localStorage.getItem("server"),
      id: localStorage.getItem("id"),
      username: localStorage.getItem("username"),
      token: localStorage.getItem("token"),
      user_id: id,
      tpassword,
    };

    try {
      setLoading(true);
      const res = await backend.clear_data(data);

      if (res?.error === "False") {
        setOpenClearModal(false);
        setSelectedUsers([]);
        toast.success(res?.message || "User data cleared successfully");
        reload();
      } else {
        toast.error(res?.message || "Failed to clear data");
      }
    } catch (err) {
      console.error(err);
      toast.error("Error clearing user data");
    } finally {
      setLoading(false);
      setTpassword("");
    }
  };

  const handleSuperEdit = useCallback(() => {
    window.user_id = item.super_id;
    window.openeditSuper?.();
  }, [item.super_id]);

  const handleMasterEdit = useCallback(() => {
    window.user_id = item.master_id;
    window.masterModalOpen?.();
  }, [item.master_id]);

  const handleUserEdit = useCallback(() => {
    window.user_id = item.id;
    window.userModalOpen?.();
  }, [item.id]);

  const handleCopyMsg = () => {
    const exchanges = [];

    const buildMargin = (intraday, carry) => {
      if (intraday_sq === 1) {
        return `Margin: ${intraday} | Carry: ${carry}`;
      }
      return `Margin: ${intraday}`;
    };

    if (nse)
      exchanges.push(
        `• NSE-FUTURE → Brokerage: ${b_nse}`,
      );

    if (nse_cash)
      exchanges.push(
        `• NSE-EQUITY → Brokerage: ${b_nse_cash}`,
      );

    if (mcx)
      exchanges.push(
        `• MCX-FUTURE → Brokerage: ${lot_volume === 0 ? b_mcx_lot : b_mcx_volume}`,
      );

    if (mcx_options)
      exchanges.push(
        `• MCX-OPTIONS → Brokerage: ${b_mcx_options}`,
      );

    if (options)
      exchanges.push(
        `• NSE-OPTIONS → Brokerage: ${b_options}`,
      );

    if (comex)
      exchanges.push(
        `• COMEX → Brokerage: ${b_comex}`,
      );

    if (crypto)
      exchanges.push(
        `• CRYPTO → Brokerage: ${b_crypto}`,
      );

    if (forex)
      exchanges.push(
        `• FOREX → Brokerage: ${b_forex}`,
      );

    if (sgx)
      exchanges.push(
        `• SGX → Brokerage: ${b_sgx}`,
      );

    if (us_stock)
      exchanges.push(
        `• US STOCK → Brokerage: ${b_us_stock}`,
      );

    if (index)
      exchanges.push(
        `• INDEX → Brokerage: ${b_index}`,
      );

    if (dgcx)
      exchanges.push(
        `• DGCX → Brokerage: ${b_dgcx}`,
      );

    if (ncdex)
      exchanges.push(
        `• NCDEX → Brokerage: ${b_ncdex}`,
      );

    const exchangeText = exchanges.length
      ? exchanges.join("\n")
      : "No Exchange Enabled";

    const msg = `
━━━━━━━━━━━━━━━━━━━━━━
🚀 Welcome To ${window.APP_NAME}
━━━━━━━━━━━━━━━━━━━━━━

👤 Name : ${name}
🔑 Username : ${username}
🔐 Password : 123123

💰 Balance : ₹${formatNumber(deposit_total)}

📊 Active Exchanges
${exchangeText}

🌐 Auto SQ.OFF : ${auto_sq ? "✅ Enabled" : "❌ Disabled"} 

🌐 Platform
Web : ${window.APP_LINK}
Android : ${window.APP_LINK_ANDROID}
iOS : ${window.APP_LINK_IOS}
Desktop : ${window.APP_LINK}

⚠️ Please read the Rules & Regulations carefully before trading.

If you face any issues, please contact upper line.

We wish you all the best and happy trading! 📈

━━━━━━━━━━━━━━━━━━━━━━
`;

    navigator.clipboard.writeText(msg);
    toast.success("Copied user message");
  };

  const profitLossClass = profit_loss > 0 ? "buytext" : "selltext";
  const profitLossNetClass = net_profit_loss > 0 ? "buytext" : "selltext";

  return (
    <>
      <div
        onDoubleClick={handleCopyMsg}
        className="menuContainer addHight text"
      >
        {userType === 1 && (
          <div
            onClick={handleSuperEdit}
            className={`menuUsername ${userType === 1 ? "small" : null} `}
          >
            <div className="user_id">{super_username}</div>
          </div>
        )}

        {(userType === 1 || userType === 2) && (
          <div
            onClick={handleMasterEdit}
            className={`menuUsername ${userType === 1 ? "small" : null} `}
          >
            <div className="user_id">{master_username}</div>
          </div>
        )}

        <div onClick={handleUserEdit} className={`menuUsername`}>
          <div className="user_id">{username}</div>
        </div>

        <div className="menuName">{formatNumber(deposit_total)}</div>
        <div className="menuName">{formatNumber(deposit_current)}</div>
        <div className={`menuName ${profitLossClass}`}>
          {formatNumber(Math.abs(profit_loss))}
        </div>
        <div className={`menuName ${profitLossNetClass}`}>
          {formatNumber(Math.abs(net_profit_loss))}
        </div>

        <div className="menuName">
          <Status id={id} status={trade} type="TRADE" />
        </div>
        <div className="menuName">
          <Status id={id} status={only_sq} type="ONLY_SQ" />
        </div>
        <div className="menuName">
          <Status id={id} status={status} type="STATUS" />
        </div>

        <div className="menuName small">{ip || "N/A"}</div>

        <div className="menuDate flex flex-col items-center justify-center">
          <div className="extraSmall">
            {moment(date_created).format("DD-MM-YYYY")}
          </div>
          <div className="small">{moment(date_created).format("HH:mm:ss")}</div>
        </div>

        <div className="menuDate small flex flex-col items-center justify-center">
          {last_login_date ? (
            <>
              <div className="extraSmall">
                {moment(last_login_date).format("DD-MM-YYYY")}
              </div>
              <div className="small">
                {moment(last_login_date).format("HH:mm:ss")}
              </div>
            </>
          ) : (
            "N/A"
          )}
        </div>

        {/* <div className="menuDate small">{formatDate(last_login_date)}</div> */}

        <div className="menuName">
          <button
            onClick={handleUserEdit}
            className={`bg-[var(--primary)] relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
          >
            EDIT
          </button>
        </div>

        {userType === 1 && (
          <div className="menuName">
            <button
              onClick={() => setOpenClearModal(true)}
              className={`bg-[var(--sell)] relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
            >
              CLEAR
            </button>
          </div>
        )}

        {(userType === 1 ||
          userType === 2 ||
          userType === 3 ||
          userType === 5 ||
          userType === 6) && (
            <div className="menuName">
              <button
                onClick={() => {
                  if (userType <= 3) return setOpenCopyModal(true);
                  toast.error("Permission Not Allowed.");
                }}
                className={`bg-[var(--sell)] relative flex items-center justify-center gap-1 px-2 py-1 text-xs font-medium uppercase rounded-md transition-all duration-300 cursor-pointer hover:opacity-80 text-white border-2 border-[var(--hover)] shadow-[0_0_6px_rgba(255,255,255,0.4)]`}
              >
                COPY
              </button>
            </div>
          )}
      </div>

      {/* 🔥 CLEAR MODAL */}
      {openClearModal && (
        <div
          className="customModalOverlay"
          onClick={() => setOpenClearModal(false)}
        >
          <div className="customModal" onClick={(e) => e.stopPropagation()}>
            <h3 className="customModalTitle">⚠️ Clear Data</h3>
            <p className="customModalWarning">
              This action will delete all data for user <b>{username}</b>.
            </p>

            <input
              type="password"
              placeholder="Enter Transaction password"
              value={tpassword}
              onChange={(e) => setTpassword(e.target.value)}
              disabled={loading}
              className="customInput"
            />

            <div className="customModalButtons">
              <button
                className="dropbtnNavSub white sell"
                onClick={() => setOpenClearModal(false)}
                disabled={loading}
              >
                Cancel
              </button>

              <button
                className="dropbtnNavSub white primary"
                onClick={handleClear}
                disabled={loading}
              >
                {loading ? "Clearing..." : "Confirm Clear"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🔥 COPY MODAL */}
      {openCopyModal && (
        <div
          onClick={() => setOpenCopyModal(false)}
          className="fixed inset-0 bg-black/40 backdrop-blur-[2px] flex items-center justify-center z-50"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="w-full max-w-lg bg-white dark:bg-[#0f0f0f] rounded-xl shadow-xl p-6
      animate-[slideUp_0.25s_ease] border border-gray-200/30 dark:border-white/10"
          >
            {/* Header */}
            <div className="flex items-center mb-4">
              <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 flex-1">
                📋 Copy From <span className="text-blue-600">{username}</span>
              </h2>

              <button
                onClick={() => setOpenCopyModal(false)}
                className="text-gray-600 dark:text-gray-300 hover:text-red-500 transition"
              >
                ✕
              </button>
            </div>

            {/* Section Title */}
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              Select what data you want to copy:
            </p>

            {/* Options */}
            <div className="flex flex-col gap-2">
              {[
                { key: "brokerage", label: "Only Brokerage" },
                { key: "margin", label: "Only Margin" },
                { key: "symbol_qty", label: "Only Symbol Qty" },
                { key: "broker", label: "Only Broker" },
              ].map((item) => (
                <label
                  key={item.key}
                  className="flex items-center gap-3 p-2 rounded-lg border
            border-gray-200 dark:border-white/10 cursor-pointer hover:bg-gray-100/70
            dark:hover:bg-white/5 transition"
                >
                  <input
                    type="checkbox"
                    checked={copyOptions[item.key]}
                    onChange={() =>
                      setCopyOptions((prev) => ({
                        ...prev,
                        [item.key]: !prev[item.key],
                      }))
                    }
                    className="w-4 h-4 accent-blue-600"
                  />
                  <span className="text-gray-800 dark:text-gray-200 text-sm">
                    {item.label}
                  </span>
                </label>
              ))}
            </div>

            <div className="my-5 border-t border-gray-200 dark:border-white/10"></div>

            {/* Users */}
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-2">
              Select users to apply:
            </p>

            <div className="max-h-48 overflow-y-auto space-y-2 pr-1">
              {filteredUsers.length === 0 ? (
                <p className="text-gray-500 text-sm text-center py-2">
                  No users found
                </p>
              ) : (
                filteredUsers
                  .filter((u) => u.id !== id)
                  .map((user) => (
                    <label
                      key={user.id}
                      className="flex items-center gap-3 p-2 rounded-lg border
                border-gray-200 dark:border-white/10 cursor-pointer hover:bg-gray-100/70
                dark:hover:bg-white/5 transition"
                    >
                      <input
                        type="checkbox"
                        checked={selectedUsers.includes(user.id)}
                        onChange={() => toggleUserSelection(user.id)}
                        className="w-4 h-4 accent-blue-600"
                      />
                      <span className="text-gray-900 dark:text-gray-200 text-sm">
                        {user.username}
                      </span>
                    </label>
                  ))
              )}
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => {
                  setSelectedUsers([]);
                  setCopyOptions({
                    brokerage: false,
                    margin: false,
                    symbol_qty: false,
                    balance: false,
                  });
                  setOpenCopyModal(false);
                }}
                disabled={loading}
                className="px-4 py-2 rounded-lg bg-gray-200 dark:bg-white/10 
          text-gray-800 dark:text-gray-200 text-sm
          hover:bg-gray-300 dark:hover:bg-white/20 transition"
              >
                Cancel
              </button>

              <button
                onClick={handleCopy}
                disabled={loading}
                className="px-4 py-2 bg-blue-600 text-white rounded-lg shadow 
          hover:bg-blue-700 hover:scale-[1.02] active:scale-95 transition text-sm"
              >
                {loading ? "Copying..." : "Copy Selected"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default memo(ListCard);
